/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nodevicesfound2Inputs */

const en_settings_nodevicesfound2 = /** @type {(inputs: Settings_Nodevicesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No devices found`)
};

/**
* | output |
* | --- |
* | "No devices found" |
*
* @param {Settings_Nodevicesfound2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_nodevicesfound2 = /** @type {((inputs?: Settings_Nodevicesfound2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nodevicesfound2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_nodevicesfound2(inputs)
});
export { settings_nodevicesfound2 as "settings_noDevicesFound" }